import { Injectable } from '@angular/core';
import { TrackerService } from '../tracker/tracker.service';

@Injectable({
  providedIn: 'root',
})
export class ArchiverService extends TrackerService {

  protected urlPath = '/v1/email-archiver';

}
